<template>
  <div>
    <PRPCategories class="py-24 border-b border-gray-50" />
    <CustomPrpInfo class="pb-24 border-b border-gray-50" />
    <FeatureVisibility class="pt-24" />
    <FootnotesCheckoutInfo class="py-24 border-b border-gray-50" />
  </div>
</template>

<script>
import CustomPrpInfo from './CustomPrpInfo.vue';
import PRPCategories from './PRPCategories.vue';
import FootnotesCheckoutInfo from './FootnotesCheckoutInfo.vue';
import FeatureVisibility from './FeatureVisibility.vue';

export default {
  name: 'PRPSettingsTab',

  components: {
    PRPCategories,
    CustomPrpInfo,
    FootnotesCheckoutInfo,
    FeatureVisibility,
  },
};
</script>
